/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { arrays_equal, get_localized_string2 } from './util.js';

import './widget.js';

/*
 *
 */
export let MVSearchConstraints = function($,mj) {

	var m_trigger_elem = null;

	function init( trigger_elem, name, onchange ) {

		m_trigger_elem = trigger_elem;

		m_trigger_elem.mjWidget( {
			type: 'dyna-set',
			useThisElement: true,
			overlayOptions: {
				OffsetParent: $('#page'),
				OverlayCssWidth: 'auto',
				GlobalOffset: true,
				OkButtonText: mjt('apply'),
				CancelButtonText: '', //mjt('cancel')
				OverlayDefaultFocused: true,
			},
			setOptions: {
				noTooltipOnLabel: true,
			},
			id: trigger_elem.prop('id'),
			name: name,
			notes1_html: mjt('search-constraints-notes1'),
			notes2_html: mjt('search-constraints-notes2'),
			get_values: function() {
				var values = [];
				for( var i=0; i<mj.search.constraints.length; ++i ) {
					var c = mj.search.constraints[i];
					values.push( [ c.term, get_localized_string2(c.title,mj.locale), c.term ] );
				}
				return values;
			},
			change: onchange,
		} );

		selectDefaultTerms(false);

		return mj.search.constraints.length!==0;
	}

	function getDefaultTerms() {
		var terms = [];
		for( var i=0; i<mj.search.constraints.length; ++i ) {
			var c = mj.search.constraints[i];
			if( c.is_default ) terms.push(c.term);
		}
		return terms;
	}

	function selectDefaultTerms( trigger ) {
		setSelectedTerms(getDefaultTerms(),trigger);
	}

	function getSelectedTerms() {
		return m_trigger_elem.mjWidget('get');
	}

	function isValidTerm( term ) {
		for( var i=0; i<mj.search.constraints.length; ++i ) {
			if( mj.search.constraints[i].term==term ) return true;
		}
		return false;
	}

	function setSelectedTerms( terms, trigger ) {
		var valid_terms = [];
		for( var t=0; t<terms.length; ++t ) {
			var term = terms[t];
			if( isValidTerm(term) ) valid_terms.push(term);
		}
		m_trigger_elem.mjWidget('set',valid_terms);
		if( trigger ) m_trigger_elem.mjWidget('trigger');

		var is_default = arrays_equal(valid_terms,getDefaultTerms());
		m_trigger_elem.toggleClass('active-marker',!is_default);
	}

	function getTermTitle( term ) {
		for( var i=0; i<mj.search.constraints.length; ++i ) {
			var c = mj.search.constraints[i];
			if( c.term==term ) {
				return get_localized_string2(c.title,mj.locale);
			}
		}
		return term;
	}

	return {
		init: init,
		getDefaultTerms: getDefaultTerms,
		selectDefaultTerms: selectDefaultTerms,
		getSelectedTerms: getSelectedTerms,
		isValidTerm: isValidTerm,
		setSelectedTerms: setSelectedTerms,
		getTermTitle: getTermTitle,
	};
}(jQuery,mj); // namespace MVSearchConstraints
